import "./StaticPages.css";

export default function AboutUs() {
  return (
    <div className="static-page">
      <h1>About Us</h1>
      <p className="lead">NovaStore is your trusted destination for instant game top-ups and in-game currency across popular mobile and PC games.</p>

      <section>
        <h2>Who We Are</h2>
        <p>Founded in Manipur, India, NovaStore was built by gamers, for gamers. We understand the frustration of complicated top-up processes, unreliable services, and overpriced diamonds. That's why we created a platform that makes game recharges simple, fast, and affordable.</p>
      </section>

      <section>
        <h2>What We Offer</h2>
        <p>We provide instant top-up services for popular games including Mobile Legends, PUBG Mobile, Free Fire, Genshin Impact, Honor of Kings, and many more. Our platform supports multiple payment methods including UPI, Paytm, and wallet balance for seamless transactions.</p>
      </section>

      <section>
        <h2>Why Choose NovaStore?</h2>
        <div className="feature-grid">
          <div className="feature-card">
            <span className="feature-icon">⚡</span>
            <h3>Instant Delivery</h3>
            <p>Most orders are processed and delivered within seconds through our automated system.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">💰</span>
            <h3>Best Prices</h3>
            <p>We offer competitive pricing with regular discounts and flash sales for our customers.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🔒</span>
            <h3>Secure Payments</h3>
            <p>All transactions are encrypted and processed through verified payment gateways.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🎧</span>
            <h3>24/7 Support</h3>
            <p>Our support team is always available to help you with any issues or questions.</p>
          </div>
        </div>
      </section>

      <section>
        <h2>Our Mission</h2>
        <p>To make game top-ups accessible, affordable, and hassle-free for every gamer in India and beyond. We believe gaming should be fun — not complicated by payment issues.</p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>Have questions? Reach out to us at <a href="mailto:support@novaofficial.in">support@novaofficial.in</a> or visit our <a href="/support">Help Center</a>.</p>
      </section>
    </div>
  );
}